import { useTranslation } from "react-i18next";
import CouponTabDetail from "../components/coupon-tab-detail";
import { CouponStatus, CouponType } from "../constant/index";
import { useGlobalStore } from "@/store/GlobalStore";
import { BusinessType } from "project-config/constants/user-info";
import { useTabStore } from "@/pages/coupon/store/tab-store";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { URLSearchParamsHelper } from "project-config/utils/url-search";

export function useGetTabsList() {
  const { t } = useTranslation("coupon");
  const {
    currentTab,
    setCurrentTab,
    couponInfo,
    setCurrentStatus,
    setActiveKey,
    qyCouponCount,
  } = useTabStore();
  const { userInfo, isDomestic, isSubAccount } = useGlobalStore();
  const location = useLocation();

  useEffect(() => {
    const urlSearchParamsHelper = new URLSearchParamsHelper(location.search);
    const filter = urlSearchParamsHelper.get("filter");
    if (!filter) return;
    let activeKeyData;
    switch (filter) {
      case "coupon":
        activeKeyData = CouponType.Animation;
        break;
      case "youth":
        activeKeyData = CouponType.Qing;
        break;
      case "voucher":
        activeKeyData = CouponType.RenderingMember;
        break;
      default:
        break;
    }
    setActiveKey(String(activeKeyData));
    setCurrentTab(activeKeyData ?? CouponType.Animation);
  }, [location, setCurrentTab, setActiveKey]);

  const currentTabsList = [
    {
      label: t("tablist_rendering_coupon"),
      key: String(CouponType.Animation),
      children: <CouponTabDetail currentTab={currentTab} />,
      visible: true,
    },
    {
      label: t("tablist_albatross_coupons"),
      key: String(CouponType.Qing),
      children: <CouponTabDetail currentTab={currentTab} />,
      visible:
        isDomestic &&
        (userInfo?.businessType === BusinessType.Animation ||
          (userInfo?.businessType === BusinessType.Picture &&
            (isSubAccount
              ? couponInfo?.filter((item) => item.type === CouponType.Qing)[0]
                  .data.length
              : qyCouponCount > 0))),
    },
    {
      label: t("tablist_free_coupon"),
      key: String(CouponType.RenderingMember),
      children: <CouponTabDetail currentTab={currentTab} />,
      visible: userInfo?.businessType === BusinessType.Picture,
    },
  ];

  const couponStatusList = [
    {
      label: t("coupon_status_all"),
      value: CouponStatus.All,
    },
    {
      label: t("coupon_status_use"),
      value: CouponStatus.BeUsable,
    },
    {
      label: t("coupon_status_timeout"),
      value: CouponStatus.Expired,
    },
  ];

  return {
    tabsList: currentTabsList.filter((p) => p.visible),
    setCurrentTab,
    couponStatusList,
    setCurrentStatus,
    currentTab,
  };
}
